var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountIconParticipant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16882_2776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 14.9999C10.5674 14.9999 12.75 12.8173 12.75 10.1249C12.75 7.43255 10.5674 5.24994 7.875 5.24994C5.18261 5.24994 3 7.43255 3 10.1249C3 12.8173 5.18261 14.9999 7.875 14.9999Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.958984 18.75C1.70813 17.5981 2.73311 16.6516 3.94086 15.9964C5.14861 15.3412 6.50089 14.998 7.87492 14.998C9.24896 14.998 10.6012 15.3412 11.809 15.9964C13.0167 16.6516 14.0417 17.5981 14.7909 18.75",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 14.9999C17.499 14.9991 18.8513 15.3418 20.0592 15.9967C21.267 16.6516 22.292 17.598 23.0409 18.7499",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3145 5.59681C14.9813 5.33084 15.6987 5.21544 16.4153 5.25886C17.1319 5.30229 17.8301 5.50346 18.46 5.848C19.0899 6.19254 19.6359 6.67196 20.059 7.25198C20.4821 7.832 20.7718 8.49832 20.9076 9.20332C21.0433 9.90831 21.0216 10.6346 20.8441 11.3302C20.6666 12.0259 20.3376 12.6738 19.8807 13.2275C19.4238 13.7813 18.8502 14.2273 18.2009 14.5337C17.5516 14.8401 16.8427 14.9993 16.1248 14.9999",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16882_2776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountIconParticipant);
export default __webpack_public_path__ + "static/media/CountIconParticipant.7b463bdba5ca66fe60a25e3d39ca161b.svg";
export { ForwardRef as ReactComponent };